import { loadCreatorDetails } from '../../onboarding/services/load-creator-details';
import type { ConnectedPlatform } from '../types';
import { mapConnectedPlatform } from './dashboard.mapper';

/** The platforms on the creator's details, oldest first, for Social. */
export async function fetchConnectedPlatforms(): Promise<ConnectedPlatform[]> {
	const { profiles } = await loadCreatorDetails();
	return profiles.map(mapConnectedPlatform);
}
